import React from 'react';
import sIcon1 from '../../images/icons/icon_clock.svg'
import sIcon2 from '../../images/icons/icon_dart_board_2.svg'
import sIcon3 from '../../images/icons/icon_target.svg'

const Policy = [
    {
        title: 'Our History',
        subTitle: 'Founded in 2018, we have been delivering innovative software, web, and mobile solutions that empower global businesses to achieve growth and digital success.',
        icon: sIcon1,
    },
    {
        title: 'Our Mission',
        subTitle: 'Our mission is to empower businesses worldwide with secure, scalable, and smart technology solutions that drive digital growth, improve efficiency, and create long-term value.',
        icon: sIcon2,
    },
    {
        title: 'Our Vision',
        subTitle: 'Our vision is to be a global leader in software innovation, shaping the future with intelligent, impactful, and sustainable technology that inspires progress.',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section bg-light">
            <div className="container">
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-md-4" key={pitem}>
                            <div className="color_function">
                                <div className="iconbox_icon">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;